module.exports = __webpack_public_path__ + "img/rocket.110f7a96.png";